import * as React from 'react';
import { useLocation } from 'react-router';

import { useApolloClient } from '@apollo/client';

import { variantIdFromUrl } from '@notino/shared/client-utils';
import { GetLoadingProductQuery } from '@notino/shared/definitions/types';

import getLoadingProductQuery from '@containers/ProductDetailContainer/queries/loadingProduct.graphql';

import { SpaLoadingSkeleton } from './SpaLoadingSkeleton';

interface ISkeletonProps {
  productId: string;
}

export const Loading: React.FC<ISkeletonProps> = ({ productId }) => {
  const { cache } = useApolloClient();
  const { pathname } = useLocation();

  const variantOrProductId = variantIdFromUrl(pathname) || productId;

  const loadingProduct = cache.readQuery<GetLoadingProductQuery>({
    query: getLoadingProductQuery,
    variables: { id: String(variantOrProductId) },
  });

  return (
    <SpaLoadingSkeleton
      product={loadingProduct?.vpProductById}
      imageDomainPath={loadingProduct?.Settings?.imageDomainPath}
    />
  );
};
